var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-nav-bar',{attrs:{"title":_vm.$t('LastTranslate.registrationAgreement')}}),_c('div',{staticClass:"main",domProps:{"innerHTML":_vm._s(_vm.chContent)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }